import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
  Divider,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate, useParams } from "react-router-dom";
import { usavigate } from "react-router-dom";
import { EditIcon, ImagesIcon, NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import Select2 from "react-select";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../constants";
import { duration } from "moment/moment";
import { PlusIcon } from "@shopify/polaris-icons";
import shape from "@material-ui/core/styles/shape";
import squareIcon from "../../Assets/Images/square.svg";
import circleIcon from "../../Assets/Images/circle.svg";
import matIcon from "../../Assets/Images/mat.svg";
import bicycleIcon from "../../Assets/Images/bicycle.svg";

const AddEditClass = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    price: "",
    name: "",
    description: "",
    isActive: true,
    studio: "",
    substudio: "",
    type: "",
    element: "",
    prerequisites: "",
    requirements: "",
    firstTimers: "",
    type: "",
    with_shoes: false,
    parent: "",
    duration1: "",
    price1: "",
    duration2: "",
    price2: "",
    duration: "",
    canvas_height: "",
    shape: "Squares",
    instructor_x: "",
    instructor_y: "",
    instructor_rotation: "",
    time_ranges: [{ from_time: "", to_time: "" }],
    time_slots: [],
    spots: [
      {
        position_x: "",
        position_y: "",
        rotation: "",
        label: "",
        is_active: 0,
        is_booked: 0,
        id: "",
      },
    ],
    is_private: false,
    is_booking_exists: false,
  });
  const handleChangePrivate = (newValue) => {
    setItem({ ...item, is_private: newValue });
  };
  const handleChangeShape = (newValue) => {
    setItem({ ...item, shape: newValue });
    setShapeError("");
  };
  const [shapeError, setShapeError] = useState("");
  const handleChangeWithShoes = (newValue) => {
    setItem({ ...item, with_shoes: newValue });
  };
  const handleChangeDuration1 = (newValue) => {
    setItem({ ...item, duration1: newValue });
    setDuration1Error("");
  };
  const [duration1Error, setDuration1Error] = useState("");
  const handleChangePrice1 = (newValue) => {
    setItem({ ...item, price1: newValue });
    setPrice1Error("");
  };
  const [price1Error, setPrice1Error] = useState("");
  const handleChangeDuration2 = (newValue) => {
    setItem({ ...item, duration2: newValue });
    setDuration2Error("");
  };
  const [duration2Error, setDuration2Error] = useState("");
  const handleChangePrice2 = (newValue) => {
    setItem({ ...item, price2: newValue });
    setPrice2Error("");
  };
  const [price2Error, setPrice2Error] = useState("");
  const handleChangeDuration = (newValue) => {
    setItem({ ...item, duration: newValue });
    setDurationError("");
  };
  const [durationError, setDurationError] = useState("");
  const handleSelectChangeLevel = (newValue) => {
    setItem({ ...item, level: newValue });
    setLevelError("");
  };
  const [levelError, setLevelError] = useState("");
  const handleSelectChangeParent = (newValue) => {
    setItem({ ...item, parent: newValue });
    setParentError("");
  };
  const [parentError, setParentError] = useState("");
  const optionsGenders = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Mixed", value: "mixed" },
  ];
  const handleSelectChangeGender = (newValue) => {
    setItem({ ...item, gender: newValue });
    setGenderError("");
  };
  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });
    setTypeError("");
  };
  const [typeError, setTypeError] = useState("");
  const [genderError, setGenderError] = useState("");
  const handleSelectChangeInstructor = (newValue) => {
    setItem({ ...item, instructor: newValue });
    setInstructorError("");
  };
  const [instructorError, setInstructorError] = useState("");

  const handleSelectChangeStudio = (newValue) => {
    setItem({ ...item, studio: newValue });
    setStudioError("");
  };
  const handleSelectChangeSubtudio = (newValue) => {
    setItem({ ...item, substudio: newValue });
    setSubstudioError("");
  };
  const [substudioError, setSubstudioError] = useState("");

  const [studioError, setStudioError] = useState("");
  const handleSelectChangeElement = (newValue) => {
    setItem({ ...item, element: newValue });
    setElementError("");
  };
  const [elementError, setElementError] = useState("");
  const handleChangeName = (newValue) => {
    setItem({ ...item, name: newValue });
    setNameError("");
  };

  const [nameError, setNameError] = useState("");
  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
    setPriceError("");
  };
  const [priceError, setPriceError] = useState("");
  const handleChangeLocation = (newValue) => {
    setItem({ ...item, location: newValue });
  };
  const handleChangeDate = (newValue) => {
    setItem({ ...item, date: newValue });
    setDateError("");
  };
  const [dateError, setDateError] = useState("");
  const handleChangeTime = (newValue) => {
    setItem({ ...item, time: newValue });
    setTimeError("");
  };
  const [timeError, setTimeError] = useState("");
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };
  const handleChangePrerequisites = (newValue) => {
    setItem({ ...item, prerequisites: newValue });
  };
  const handleChangeRequirements = (newValue) => {
    setItem({ ...item, requirements: newValue });
  };
  const handleChangeFirstTimers = (newValue) => {
    setItem({ ...item, firstTimers: newValue });
  };

  const handleChangetimeFrom = (newValue) => {
    setItem({ ...item, timeFrom: newValue });
  };
  const handleChangeTimeTo = (newValue) => {
    setItem({ ...item, timeTo: newValue });
  };

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const handleChangeCapacityMale = (newValue) => {
    setItem({ ...item, capacityMale: newValue });
    setMaleCapacityError("");
  };
  const [maleCapacityError, setMaleCapacityError] = useState("");
  const handleChangeCapacityFemale = (newValue) => {
    setItem({ ...item, capacityFemale: newValue });
    setFemaleCapacityError("");
  };
  const [femaleCapacityError, setFemaleCapacityError] = useState("");
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts jpegs and pngs (Required size: 600x500 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [optionsInstructors, setOptionsInstructors] = useState([]);
  const [optionsStudios, setOptionsStudios] = useState([]);
  const [optionsElements, setOptionsElements] = useState([]);
  const [optionsSubtudios, setOptionsSubtudios] = useState([]);
  const [activePreview, setActivePreview] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    let responseInstructors = [];
    let responseElements = [];
    try {
      responseInstructors = await axios.get(`/instructors-list`);
      setOptionsInstructors(
        responseInstructors.data.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseElements = await axios.get(`/elements`);
      setOptionsElements(
        responseElements.data.data.data.map((item, index) => {
          return {
            label: item.title,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props.type === "edit") {
      try {
        responseItem = await axios.get(`/classes/${id}`);
        console.log(
          "shape=",
          responseItem?.data?.data?.spot_structure?.general.shape
        );
        setItem({
          name: responseItem?.data?.data?.name
            ? responseItem.data.data.name
            : "",
          type: responseItem?.data?.data?.type
            ? responseItem.data.data.type
            : "",
          parent: responseItem?.data?.data?.parent_type
            ? responseItem.data.data.parent_type
            : "",
          price:
            responseItem?.data?.data?.price !== null
              ? responseItem.data.data.price
              : "",
          description: responseItem?.data?.data?.description
            ? responseItem.data.data.description
            : "",
          prerequisites: responseItem?.data?.data?.prerequisites
            ? responseItem.data.data.prerequisites
            : "",
          requirements: responseItem?.data?.data?.requirements
            ? responseItem.data.data.requirements
            : "",
          firstTimers: responseItem?.data?.data?.first_timers
            ? responseItem.data.data.first_timers
            : "",
          with_shoes: responseItem?.data?.data?.with_shoes ? true : false,
          image: responseItem?.data?.data?.background_image
            ? responseItem.data.data.background_image
            : "",
          location: responseItem?.data?.data?.location
            ? responseItem.data.data.location
            : "",
          element:
            responseItem?.data?.data?.element !== null
              ? {
                  label: responseItem?.data?.data?.element?.title,
                  value: String(responseItem?.data?.data?.element?.id),
                }
              : "",
          studio: responseItem?.data?.data?.studio
            ? {
                label: responseItem?.data?.data?.studio?.name,
                value: String(responseItem?.data?.data?.studio?.id),
              }
            : "",
          substudio: responseItem?.data?.data?.sub_studio
            ? {
                label: responseItem?.data?.data?.sub_studio?.name,
                value: String(responseItem?.data?.data?.sub_studio?.id),
              }
            : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
          level: responseItem?.data?.data?.level
            ? responseItem.data.data.level
            : "",
          duration1: responseItem?.data?.data?.duration_1
            ? responseItem.data.data.duration_1
            : "",
          price1: responseItem?.data?.data?.price_1
            ? responseItem.data.data.price_1
            : "",
          duration2: responseItem?.data?.data?.duration_2
            ? responseItem.data.data.duration_2
            : "",
          price2: responseItem?.data?.data?.price_2
            ? responseItem.data.data.price_2
            : "",
          duration: responseItem?.data?.data?.duration
            ? responseItem.data.data.duration
            : "",
          canvas_height:
            responseItem?.data?.data?.spot_structure &&
            responseItem?.data?.data?.spot_structure?.general &&
            responseItem?.data?.data?.spot_structure?.general?.canvas_height
              ? responseItem?.data?.data?.spot_structure?.general?.canvas_height
              : "",
          shape:
            responseItem?.data?.data?.spot_structure &&
            responseItem?.data?.data?.spot_structure?.general &&
            responseItem?.data?.data?.spot_structure?.general?.shape
              ? responseItem?.data?.data?.spot_structure?.general?.shape
              : "Squares",
          instructor_x:
            responseItem?.data?.data?.spot_structure &&
            responseItem?.data?.data?.spot_structure?.general &&
            responseItem?.data?.data?.spot_structure?.general?.instructor &&
            responseItem?.data?.data?.spot_structure?.general?.instructor
              ?.position_x
              ? String(
                  responseItem?.data?.data?.spot_structure?.general?.instructor
                    ?.position_x
                )
              : "",
          instructor_y:
            responseItem?.data?.data?.spot_structure &&
            responseItem?.data?.data?.spot_structure?.general &&
            responseItem?.data?.data?.spot_structure?.general?.instructor &&
            responseItem?.data?.data?.spot_structure?.general?.instructor
              ?.position_y
              ? String(
                  responseItem?.data?.data?.spot_structure?.general?.instructor
                    ?.position_y
                )
              : "",
          instructor_rotation:
            responseItem?.data?.data?.spot_structure &&
            responseItem?.data?.data?.spot_structure?.general &&
            responseItem?.data?.data?.spot_structure?.general?.instructor &&
            responseItem?.data?.data?.spot_structure?.general?.instructor
              ?.rotation
              ? String(
                  responseItem?.data?.data?.spot_structure?.general?.instructor
                    ?.rotation
                )
              : "",

          spots:
            responseItem?.data?.data?.seats &&
            responseItem?.data?.data?.seats.length
              ? responseItem?.data?.data?.seats.map((item) => ({
                  position_x: item.position_x,
                  position_y: item.position_y,
                  rotation: item.rotation,
                  label: item.label,
                  is_active: item.is_active,
                  is_booked: 0,
                  id: item.id,
                }))
              : [],
          is_private: responseItem?.data?.data?.is_private ? true : false,
          is_booking_exists: responseItem?.data?.data?.is_booking_exists,
        });
      } catch (error) {
        console.log(error);
      }
    }

    setIsSaving(false);
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have be saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    console.log("files=", files);
    setIsImageUploading(true);

    const form_data = new FormData();
    form_data.append("entity", "session");
    form_data.append("image", files[files.length - 1]);
    axios
      .post("/s3/save-file", form_data)
      .then((res) => {
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        imageKey.current = res.data.data;
      })
      .catch((err) => console.log(err));
  };

  const handleChangeTimeCanvasHeight = (newValue) => {
    setItem({ ...item, canvas_height: newValue });
    setCanvasHeightError("");
  };
  const [canvasHeightError, setCanvasHeightError] = useState("");
  const handleChangeTimeInstructorX = (newValue) => {
    setItem({ ...item, instructor_x: newValue });
    setInstructorXError("");
  };
  const [instructorXError, setInstructorXError] = useState("");
  const handleChangeTimeInstructorY = (newValue) => {
    setItem({ ...item, instructor_y: newValue });
    setInstructorYError("");
  };
  const [instructorYError, setInstructorYError] = useState("");
  const handleChangeTimeInstructorRotation = (newValue) => {
    setItem({ ...item, instructor_rotation: newValue });
    setInstructorRotationError("");
  };
  const [instructorRotationError, setInstructorRotationError] = useState("");
  const handleAddSpot = () => {
    setItem({
      ...item,
      spots: [
        ...item.spots,
        {
          position_x: "",
          position_y: "",
          rotation: "",
          label: "",
          is_active: 0,
          is_booked: 0,
          id: "",
        },
      ],
    });
  };
  const handleRemoveSpot = (index) => {
    const updatedSpots = [...item.spots];
    updatedSpots.splice(index, 1);
    setItem({ ...item, spots: updatedSpots });
  };
  const handleChangeSpot = (index, field, value) => {
    const updatedSpots = [...item.spots];
    if (field === "is_active" || field === "is_booked") {
      updatedSpots[index][field] = value ? 1 : 0;
    } else {
      updatedSpots[index][field] = value;
    }
    setItem({ ...item, spots: updatedSpots });
  };
  useEffect(() => {
    (item.parent === "studio" || item.parent === "substudio") &&
      axios
        .get(`elements/${item.element.value}/studios`)
        .then((result) => {
          setOptionsStudios(
            result.data.data.data.map((item, index) => {
              return {
                label: item?.name && item.name,
                value: String(item.id),
              };
            })
          );
        })

        .catch((err) => console.log(err));
  }, [item?.element?.value]);

  useEffect(() => {
    item.parent === "substudio" &&
      axios
        .get(
          `/elements/${item.element.value}/studios/${item.studio.value}/sub-studios`
        )
        .then((result) => {
          setOptionsSubtudios(
            result.data.data.data.map((item, index) => {
              return {
                label: item?.name && item.name,
                value: String(item.id),
              };
            })
          );
        })

        .catch((err) => console.log(err));
  }, [item?.studio?.value]);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/classes/${id}`)
      .then((result) => {
        navigate(`/admin/${props.path}`);
      })
      .catch((err) => console.log(err));
  };
  const [spotsError, setSpotsError] = useState("");
  const isValidSpot = (spot) => {
    return (
      spot.position_x !== "" &&
      spot.position_y !== "" &&
      spot.rotation !== "" &&
      spot.label !== ""
    );
  };
  return (
    <Page
      title={props.title}
      backAction={{ onAction: () => navigate(`/admin/${props?.path}`) }}
      // narrowWidth
      // primaryAction={
      //   item.type === "spot"
      //     ? {
      //         content: "Preview Seats",
      //         onAction: () => setActivePreview(true),
      //       }
      //     : null
      // }
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <TextField
            value={item.name}
            onChange={handleChangeName}
            label="Name "
            error={nameError}
          />
          <Select
            label="Layout"
            options={[
              { label: "Default", value: "default" },
              { label: "Spot", value: "spot" },
              { label: "Duration", value: "duration" },
            ]}
            onChange={handleSelectChangeType}
            value={item.type}
            placeholder="Please select"
            error={typeError}
          />

          {props.path === "classes" ? (
            <Select
              label="Parent"
              options={[
                { label: "Element", value: "element" },
                { label: "Studio", value: "studio" },
                { label: "Substudio", value: "substudio" },
              ]}
              placeholder="Please select"
              onChange={handleSelectChangeParent}
              value={item.parent}
              error={parentError}
            />
          ) : null}

          {props.path === "classes" ? (
            item.parent === "element" ? (
              <FormLayout>
                <Text>Element</Text>
                <Select2
                  options={optionsElements}
                  onChange={handleSelectChangeElement}
                  value={item.element}
                  placeholder="Please select"
                  styles={{
                    // Fixes the overlapping problem of the compont
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
                <InlineError message={elementError} />
              </FormLayout>
            ) : item.parent === "studio" ? (
              <FormLayout.Group>
                <FormLayout>
                  <Text>Element</Text>
                  <Select2
                    options={optionsElements}
                    onChange={handleSelectChangeElement}
                    value={item.element}
                    placeholder="Please select"
                    styles={{
                      // Fixes the overlapping problem of the compont
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                  <InlineError message={elementError} />
                </FormLayout>
                <FormLayout>
                  <Text>Studio</Text>
                  <Select2
                    options={optionsStudios}
                    onChange={handleSelectChangeStudio}
                    value={item.studio}
                    placeholder="Please select"
                    styles={{
                      // Fixes the overlapping problem of the compont
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                  <InlineError message={studioError} />
                </FormLayout>
              </FormLayout.Group>
            ) : item.parent === "substudio" ? (
              <FormLayout.Group>
                <FormLayout>
                  <Text>Element</Text>
                  <Select2
                    options={optionsElements}
                    onChange={handleSelectChangeElement}
                    value={item.element}
                    placeholder="Please select"
                    styles={{
                      // Fixes the overlapping problem of the compont
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                  <InlineError message={elementError} />
                </FormLayout>
                <FormLayout>
                  <Text>Studio</Text>
                  <Select2
                    options={optionsStudios}
                    onChange={handleSelectChangeStudio}
                    value={item.studio}
                    placeholder="Please select"
                    styles={{
                      // Fixes the overlapping problem of the compont
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                  <InlineError message={studioError} />
                </FormLayout>
                <FormLayout>
                  <Text>Substudio</Text>
                  <Select2
                    options={optionsSubtudios}
                    onChange={handleSelectChangeSubtudio}
                    value={item.substudio}
                    placeholder="Please select"
                    styles={{
                      // Fixes the overlapping problem of the compont
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                  <InlineError message={substudioError} />
                </FormLayout>
              </FormLayout.Group>
            ) : null
          ) : null}

          {item.type !== "duration" ? (
            <TextField
              value={item.price}
              onChange={handleChangePrice}
              label="Price "
              error={priceError}
              type="number"
            />
          ) : null}

          {item.type === "duration" ? (
            <FormLayout.Group>
              <TextField
                value={item.duration1}
                onChange={handleChangeDuration1}
                label="Duration 1"
                suffix="min"
              />
              <TextField
                value={item.price1}
                onChange={handleChangePrice1}
                label="Price 1"
                error={price1Error}
              />
              <TextField
                value={item.duration2}
                onChange={handleChangeDuration2}
                label="Duration 2"
                error={duration2Error}
                suffix="min"
              />
              <TextField
                value={item.price2}
                onChange={handleChangePrice2}
                label="Price 2"
                error={price2Error}
              />
            </FormLayout.Group>
          ) : null}
          {/* {item.type === "spot" || item.type === "duration" ? (
            <TextField
              value={item.location}
              onChange={handleChangeLocation}
              label="Location "
            />
          ) : null} */}
          {item.type === "spot" ? (
            <TextField
              value={item.duration}
              onChange={handleChangeDuration}
              label="Duration"
              type="number"
              error={durationError}
            />
          ) : null}

          {/* <FormLayout.Group>
            <TextField
              value={item.date}
              onChange={handleChangeDate}
              label="Date"
              type="date"
              error={dateError}
            />
            {item.type === "default" || item.type === "spot" ? (
              <TextField
                value={item.time}
                onChange={handleChangeTime}
                label="Time"
                type="time"
                error={timeError}
              />
            ) : item.type === "duration" ? (
              <TextField
                value={item.duration}
                onChange={handleChangeDuration}
                label="Duration"
              />
            ) : null}
          </FormLayout.Group> */}

          {/* <FormLayout.Group>
            <TextField
              value={item.timeFrom}
              onChange={handleChangetimeFrom}
              label="Starts at"
              type="time"
            />
            <TextField
              value={item.timeTo}
              onChange={handleChangeTimeTo}
              label="Ends at"
              type="time"
            />
          </FormLayout.Group> */}
          {/* {item.type === "default" ? (
            <Select
              label="Gender"
              options={optionsGenders}
              onChange={handleSelectChangeGender}
              value={item.gender}
              placeholder="Please select"
              error={genderError}
            />
          ) : null} */}
          {/* <FormLayout.Group>
            {(item.gender === "male" || item.gender === "mixed") && (
              <TextField
                value={item.capacityMale}
                onChange={handleChangeCapacityMale}
                label="Male Capacity"
                error={maleCapacityError}
                type="number"
              />
            )}
            {(item.gender === "female" || item.gender === "mixed") && (
              <TextField
                value={item.capacityFemale}
                onChange={handleChangeCapacityFemale}
                label="Female Capacity"
                error={femaleCapacityError}
                type="number"
              />
            )}
          </FormLayout.Group> */}
          {item.type === "default" || item.type === "spot" ? (
            <Select
              label="Level"
              options={[
                { label: "Beginner", value: "beginner" },
                { label: "Intermediate", value: "intermediate" },
                { label: "Advanced", value: "advanced" },
                { label: "Any", value: "any" },
              ]}
              onChange={handleSelectChangeLevel}
              value={item.level}
              placeholder="Please select"
              error={levelError}
            />
          ) : null}

          {item.type === "spot" && (
            <FormLayout>
              <Divider borderColor="border-inverse" />
              <Text as="p" fontWeight="semibold">
                SPOTS
              </Text>
              <Select
                placeholder="Please select"
                label="Shape"
                options={[
                  { label: "Squares", value: "Squares" },
                  { label: "Circles", value: "Circles" },
                  { label: "Bicycle", value: "Bicycle" },
                  { label: "Mat", value: "Mat" },
                ]}
                onChange={handleChangeShape}
                value={item.shape}
                error={shapeError}
              />
              <TextField
                value={item.canvas_height}
                onChange={handleChangeTimeCanvasHeight}
                label="Canvas Height"
                error={canvasHeightError}
                type="number"
                prefix="%"
              />
              <Text>Instructor Position</Text>
              <FormLayout.Group condensed>
                <TextField
                  value={item.instructor_x}
                  onChange={handleChangeTimeInstructorX}
                  label="X"
                  type="number"
                  prefix="%"
                  error={instructorXError}
                />
                <TextField
                  value={item.instructor_y}
                  onChange={handleChangeTimeInstructorY}
                  label="Y"
                  type="number"
                  prefix="%"
                  error={instructorYError}
                />
                <TextField
                  value={item.instructor_rotation}
                  onChange={handleChangeTimeInstructorRotation}
                  label="Rotation"
                  type="number"
                  prefix="°"
                  error={instructorRotationError}
                />
              </FormLayout.Group>
              <Text>Seats</Text>

              {item.spots?.map((spot, index) => (
                <div key={index}>
                  <FormLayout>
                    <FormLayout.Group condensed>
                      <TextField
                        label={index === 0 ? "Label" : ""}
                        value={spot.label}
                        onChange={(value) =>
                          handleChangeSpot(index, "label", value)
                        }
                      />
                      <TextField
                        type="number"
                        prefix="%"
                        label={index === 0 ? "X" : ""}
                        value={spot.position_x}
                        onChange={(value) =>
                          handleChangeSpot(index, "position_x", value)
                        }
                      />
                      <TextField
                        type="number"
                        prefix="%"
                        label={index === 0 ? "Y" : ""}
                        value={spot.position_y}
                        onChange={(value) =>
                          handleChangeSpot(index, "position_y", value)
                        }
                      />
                      <TextField
                        type="number"
                        prefix="°"
                        label={index === 0 ? "Rotation" : ""}
                        value={spot.rotation}
                        onChange={(value) =>
                          handleChangeSpot(index, "rotation", value)
                        }
                      />

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: index === 0 ? "1.6rem" : "0rem",
                        }}
                      >
                        <Checkbox
                          label="Active"
                          checked={parseInt(spot.is_active) ? true : false}
                          onChange={(value) =>
                            handleChangeSpot(index, "is_active", value)
                          }
                        />
                        {/* {props?.type === "add" ? ( */}
                        <div style={{ marginLeft: "1rem" }}>
                          <Button
                            onClick={() => handleRemoveSpot(index)}
                            variant="primary"
                            tone="critical"
                            // disabled={props?.type === "edit"}
                          >
                            Remove
                          </Button>
                        </div>
                        {/* ) : null} */}
                      </div>
                    </FormLayout.Group>
                    {/* <Checkbox
                      label="Active"
                      checked={parseInt(spot.is_active) ? true : false}
                      onChange={(value) =>
                        handleChangeSpot(index, "is_active", value)
                      }
                    /> */}
                    {/* <Checkbox
                      label="Booked"
                      checked={parseInt(spot.is_booked) ? true : false}
                      onChange={(value) =>
                        handleChangeSpot(index, "is_booked", value)
                      }
                    /> */}
                    <Divider borderColor="border-inverse" />
                  </FormLayout>
                </div>
              ))}
              <InlineError message={spotsError} />
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: `${item.canvas_height}vh`,
                  border: "1px solid black",
                  margin: "auto",
                  overflow: "hidden",
                }}
              >
                {item.spots
                  .concat({
                    position_x: item.instructor_x,
                    position_y: item.instructor_y,
                    rotation: item.instructor_rotation,
                    label: "I",
                  })
                  .map((seat, index) => (
                    <div
                      key={index}
                      style={{
                        position: "absolute",
                        width: "30px",
                        height: "30px",
                        // backgroundColor:
                        //   index ===
                        //   item.spots.concat({
                        //     position_x: item.instructor_x,
                        //     position_y: item.instructor_y,
                        //     rotation: item.instructor_rotation,
                        //     label: "I",
                        //   }).length -
                        //     1
                        //     ? "grey"
                        //     : "white",
                        color: "black",
                        // border: "1px solid black",
                        transform: `translate(-50%, -50%) rotate(${seat.rotation}deg)`,
                        top:
                          seat.position_y === "100"
                            ? "calc(100% - 30px)"
                            : seat.position_y + "%",
                        left:
                          seat.position_x === "100"
                            ? "calc(100% - 30px)"
                            : seat.position_x + "%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        overflow: "hidden",
                        opacity: seat?.is_active === 0 ? "0.4" : "1",
                      }}
                    >
                      <img
                        style={{
                          position: "absolute",
                          fontSize: "24px",
                          // color: index === item.spots.length ? "green" : "red",
                          width: "100%",
                          height: "100%",
                          zIndex: -1,
                        }}
                        src={
                          item.shape === "Squares"
                            ? squareIcon
                            : item.shape === "Circles"
                            ? circleIcon
                            : item.shape === "Mat"
                            ? matIcon
                            : bicycleIcon
                        }
                      ></img>

                      <span
                        style={{
                          position: "relative",
                          zIndex: 1,
                          color: "white",
                        }}
                      >
                        {item.shape !== "Bicycle" ? seat.label : ""}
                      </span>
                      {/* {seat.label} */}
                    </div>
                  ))}
              </div>
              <Button
                fullWidth
                variant="primary"
                onClick={handleAddSpot}
                icon={PlusIcon}
              >
                Add Seat
              </Button>
            </FormLayout>
          )}

          {/* <Text>Instructor</Text>
          <Select2
            options={optionsInstructors}
            onChange={handleSelectChangeInstructor}
            value={item.instructor}
            placeholder="Please select"
            styles={{
              // Fixes the overlapping problem of the compont
              menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
          /> */}
          <InlineError message={instructorError} />
          <Text>Description </Text>
          <JoditEditor
            value={item.description}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescription}
          />
          <Text>Prerequisites</Text>
          <JoditEditor
            value={item.prerequisites}
            config={EDITOR_CONFIG}
            onBlur={handleChangePrerequisites}
          />

          <Text>Requirements</Text>
          <JoditEditor
            value={item.requirements}
            config={EDITOR_CONFIG}
            onBlur={handleChangeRequirements}
          />
          <Text>First Timers</Text>
          <JoditEditor
            value={item.firstTimers}
            config={EDITOR_CONFIG}
            onBlur={handleChangeFirstTimers}
          />

          <Text>Image</Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpeg,.jpg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>

          {props?.type === "edit" ? (
            <FormLayout>
              <Text>Manage Gallery</Text>
              <Button
                fullWidth
                variant="primary"
                icon={EditIcon}
                onClick={() => navigate(`/admin/${props.path}/${id}/gallery`)}
              >
                Gallery
              </Button>
            </FormLayout>
          ) : null}
          <Checkbox
            label="Request shoe size"
            checked={item.with_shoes}
            onChange={handleChangeWithShoes}
          />
          <Checkbox
            label="Private"
            checked={item.is_private}
            onChange={handleChangePrivate}
          />
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setActiveDelete(true);
              }}
              disabled={item.is_booking_exists}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activePreview}
        onClose={() => setActivePreview(false)}
        title="Seats"
        // primaryAction={{
        //   content: "Yes",
        //   onAction: handleYesAccept,
        //   loading: isSaving,
        // }}
        // secondaryActions={[
        //   {
        //     content: "No",
        //     loading: isSaving,
        //     onAction: handleChangeModalAccept,
        //   },
        // ]}
      >
        <Modal.Section>
          {/* <div
            style={{
              position: "relative",
              width: "100%",
              height: `${item.canvas_height}vh`,
              border: "1px solid black",
              margin: "auto",
              overflow: "hidden",
            }}
          >
            {item.spots
              .concat({
                position_x: item.instructor_x,
                position_y: item.instructor_y,
                rotation: item.instructor_rotation,
                label: "I",
              })
              .map((seat, index) => (
                <div
                  key={index}
                  style={{
                    position: "absolute",
                    width: "30px",
                    height: "30px",
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid black",
                    transform: `translate(-50%, -50%) rotate(${seat.rotation}deg)`,
                    top:
                      seat.position_y === "100"
                        ? "calc(100% - 30px)"
                        : seat.position_y + "%",
                    left:
                      seat.position_x === "100"
                        ? "calc(100% - 30px)"
                        : seat.position_x + "%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "center",
                    overflow: "hidden",
                  }}
                >
                  {seat.label}
                </div>
              ))}
          </div> */}
        </Modal.Section>
      </Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.name ||
      (!item.level && (item.type === "default" || item.type === "spot")) ||
      (item.parent === "" && props.path === "classes") ||
      item.type === "" ||
      (item.parent === "studio" && item.studio === "") ||
      (item.parent === "studio" && item.element === "") ||
      (item.element === "" && props.path === "classes") ||
      ((item.parent === "studio" || item.parent === "substudio") &&
        item.studio === "") ||
      (item.parent === "studio" && item.studio === "") ||
      (item.parent === "substudio" && item.substudio === "") ||
      (!item.price && item.type !== "duration") ||
      (item.type === "duration" &&
        (!item.duration1 || !item.price1 || !item.duration2 || !item.price2)) ||
      (item.type === "spot" && !item.canvas_height) ||
      (item.type === "spot" && !item.shape) ||
      (item.type === "spot" && !item.instructor_x) ||
      (item.type === "spot" && !item.instructor_y) ||
      (item.type === "spot" && !item.instructor_rotation) ||
      (item.type === "spot" && !item.duration) ||
      (!item.spots.every(isValidSpot) && item.type === "spot")
      // !item.spots.some(
      //   (spot) =>
      //     spot.position_x && spot.position_y && spot.rotation && spot.label
      // ) ||
    ) {
      !item.name && setNameError("This field is required");
      !item.price &&
        item.type !== "duration" &&
        setPriceError("This field is required");
      item.parent === "" &&
        props.path === "classes" &&
        setParentError("This field is required");
      item.type === "" && setTypeError("Please select an option");
      item.element === "" &&
        props.path === "classes" &&
        setElementError("Please select an option");
      (item.parent === "studio" || item.parent === "substudio") &&
        item.studio === "" &&
        setStudioError("Please select an option");
      item.parent === "substudio" &&
        item.substudio === "" &&
        setSubstudioError("Please select an option");
      !item.level &&
        (item.type === "default" || item.type === "spot") &&
        setLevelError("Please select an option");
      item.type === "duration" &&
        !item.duration1 &&
        setDuration1Error("This field is required");
      item.type === "duration" &&
        !item.price1 &&
        setPrice1Error("This field is required");
      item.type === "duration" &&
        !item.duration2 &&
        setDuration2Error("This field is required");
      item.type === "duration" &&
        !item.price2 &&
        setPrice2Error("This field is required");
      item.type === "spot" &&
        !item.canvas_height &&
        setCanvasHeightError("This field is required");
      item.type === "spot" &&
        !item.instructor_x &&
        setInstructorXError("This field is required");
      item.type === "spot" &&
        !item.instructor_y &&
        setInstructorYError("This field is required");
      item.type === "spot" &&
        !item.instructor_rotation &&
        setInstructorRotationError("This field is required");
      item.type === "spot" &&
        !item.duration &&
        setDurationError("This field is required");
      item.type === "spot" &&
        !item.shape &&
        setShapeError("Please select an option");
      // !item.spots.some(
      //   (spot) =>
      //     spot.position_x && spot.position_y && spot.rotation && spot.label
      // ) && setSpotsError("Please make sure to fill at least one seat");
      !item.spots.every(isValidSpot) &&
        item.type === "spot" &&
        setSpotsError("Please make sure to fill all seats values");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("type", item.type);
      item.type !== "duration" && form_data.append("price", item.price);
      (item.type === "default" || item.type === "spot") &&
        form_data.append("level", item.level);
      form_data.append("parent_type", item.parent);
      (item.parent === "studio" || item.parent === "substudio") &&
        form_data.append("studio_id", item.studio.value);
      item.parent === "substudio" &&
        form_data.append("sub_studio_id", item.substudio.value);
      item.name && form_data.append("name", item.name);

      form_data.append(
        "element_id",
        props.path === "events" ? "8" : item.element.value
      );
      item.type === "duration" &&
        form_data.append("duration_1", item.duration1);
      item.type === "duration" && form_data.append("price_1", item.price1);
      item.type === "duration" &&
        form_data.append("duration_2", item.duration2);
      item.type === "duration" && form_data.append("price_2", item.price2);
      item.type === "spot" && form_data.append("duration", item.duration);
      item.description && form_data.append("description", item.description);
      item.prerequisites &&
        form_data.append("prerequisites", item.prerequisites);
      item.requirements && form_data.append("requirements", item.requirements);
      item.firstTimers && form_data.append("first_timers", item.firstTimers);
      // form_data.append("location", item.location);
      imageKey.current &&
        form_data.append("background_image", imageKey.current);
      form_data.append("is_active", item.isActive ? 1 : 0);
      form_data.append("is_event", 0);
      props.type === "edit" && form_data.append("_method", "PATCH");
      if (item.type === "spot") {
        form_data.append("seats_general_settings[shape]", item.shape);
        form_data.append(
          "seats_general_settings[canvas_height]",
          item.canvas_height
        );
        form_data.append(
          "seats_general_settings[instructor][position_x]",
          item.instructor_x
        );
        form_data.append(
          "seats_general_settings[instructor][position_y]",
          item.instructor_y
        );
        form_data.append(
          "seats_general_settings[instructor][rotation]",
          item.instructor_rotation
        );
        item.spots.forEach((selected, index) => {
          form_data.append(
            `seats_positions[${index}][position_x]`,
            selected.position_x
          );
          form_data.append(
            `seats_positions[${index}][position_y]`,
            selected.position_y
          );
          form_data.append(
            `seats_positions[${index}][rotation]`,
            selected.rotation
          );
          form_data.append(`seats_positions[${index}][label]`, selected.label);
          form_data.append(
            `seats_positions[${index}][is_active]`,
            selected.is_active ? 1 : 0
          );
          props?.type === "edit" &&
            form_data.append(`seats_positions[${index}][id]`, selected.id);
          // form_data.append(
          //   `seats_positions[${index}][is_booked]`,
          //   selected.is_booked ? 1 : 0
          // );
        });
      }
      form_data.append("with_shoes", item.with_shoes ? 1 : 0);
      form_data.append("is_private", item.is_private ? 1 : 0);
      props.type === "add"
        ? axios
            .post(`/classes`, form_data)
            .then((result) => {
              navigate(`/admin/${props.path}`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/classes/${id}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditClass;
